import _ from 'lodash';
import reserveInfo from './reserveInfo';
import roomManagement from './roomManagement';
export default _.union(
  reserveInfo,
  roomManagement,
  [{
    name: 'receptionSystem',
    path: '/receptionSystem',
    meta: { title: '招接待宾馆系统' },
    component: require('views/common/blank.vue').default
  }]
);
